import GestioneLicenze from './../views/GestioneLicenze';
import Statistiche from './../views/Statistiche';
import LogAccessi from './../views/LogAccessi';
import LogLicenze from './../views/LogLicenze';

// al momento non vengono usate da nessuna parte
export const routes = [
    /* {
        path: '/home',
        component: HomePage
    }, */
    {
        path: '/gestione-licenze',
        component: GestioneLicenze
    },
    {
        path: '/esporta-ed-invia',
        component: GestioneLicenze
    },
    {
        path: '/statistiche',
        component: Statistiche
    },
    {
        path: '/log-accessi',
        component: LogAccessi
    },
    {
        path: '/log-licenze',
        component: LogLicenze
    },
    {
        path: '/amministra-utenti',
        component: GestioneLicenze
    }
];


export const menu_entries_admin = [
    {
        text: 'Home',
        path: '/',
        icon: 'home'
    },
    {
        text: 'Gestione Licenze',
        path: '/gestione-licenze',
        icon: 'fields'
    },
    /*
    {
        text: 'Esporta ed Invia',
        path: '/esporta-ed-invia',
        icon: 'export'
    },
    */
    {
        text: 'Statistiche',
        path: '/statistiche',
        icon: 'chart'
    },
    {
        text: 'Log Accessi',
        path: '/log-accessi',
        icon: 'globe'
    },
    {
        text: 'Log Licenze',
        path: '/log-licenze',
        icon: 'pinright'
    },
    {
        text: 'Amministra Utenti',
        path: '/Identity/Account/Users',
        icon: 'card'
    },/*
    {
        text: 'Examples',
        icon: 'folder',
        items: [
            {
                text: 'Profile',
                path: '/profile'
            },
            {
                text: 'Display Data',
                path: '/display-data'
            }
        ]
    }*/
];

export const menu_entries_user = [
    {
        text: 'Home',
        path: '/',
        icon: 'home'
    },
    {
        text: 'Gestione Licenze',
        path: '/gestione-licenze',
        icon: 'fields'
    },
    /*
    {
        text: 'Esporta ed Invia',
        path: '/esporta-ed-invia',
        icon: 'export'
    },
    */
    {
        text: 'Statistiche',
        path: '/statistiche',
        icon: 'chart'
    }
];

export const menu_entries_anon = [
    {
        text: 'Home',
        path: '/',
        icon: 'home'
    }
];


export const panel_menu_entries_authenticated = [
    {
        text: 'Profilo',
        path: '/Identity/Account/Manage'
    },
    {
        text: 'Logout',
        path: '/Identity/Account/LogoutPage'
    },
];

export const panel_menu_entries_anon = [
    {
        text: 'Login',
        path: '/Identity/Account/Login'
    }
];
